module.exports = __webpack_public_path__ + "2d36fc092a54d57fda4636f2139785bd.png";


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/device.png
// module id = 71
// module chunks = 0